import s from './LeaderboardPosition.module.sass';

import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslator, useUnitName, useUserInfo } from '$hooks';
import { AnimatedEmoji, Block, Button } from '$uikit';
import { goTo, showModal } from '$navigation/helper';
import { LEADERBOARD } from '$shared/constants/pages';
import { IcGift28 } from '$assets';
import { leaderboardActions, selectLeaderboard } from '$store/leaderboard';
import { formatCurrency } from '$utils';

export const LeaderboardPosition: FC<{ position: number; userId: number }> = ({
  position,
  userId,
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const user = useUserInfo(userId);
  const name = useUnitName(user, 'dative', 'firstName');
  const { prizes, currency } = useSelector(selectLeaderboard);

  useEffect(() => {
    dispatch(leaderboardActions.load({ main: true }));
  }, [dispatch]);

  const prizeFund = Object.values(prizes).reduce((acc, value) => acc + value, 0);

  if (prizeFund <= 0) {
    return null;
  }

  const prize = formatCurrency(prizeFund, currency);

  return (
    <Block className={s.wrap}>
      <AnimatedEmoji emoji="🎃" loop size={48} />
      <div className={s.title}>
        <span>#{position}</span> {t('profile_leaderboard_title', { prize })}
      </div>
      <div className={s.caption}>
        {t('profile_leaderboard_caption', {
          name,
        })}
      </div>
      <div className={s.button}>
        <Button
          size="small"
          fillColor="darkred"
          color="white"
          onClick={() => showModal(`gift${userId}`)}
          iconRight={<IcGift28 width={18} />}
        >
          {t('profile_leaderboard_send_gift')}
        </Button>
      </div>
      <div className={s.buttonContest}>
        <Button size="small" mode="inline" onClick={() => goTo(LEADERBOARD)}>
          {t('profile_leaderboard_view_contest')}
        </Button>
      </div>
    </Block>
  );
};
